<ion-card>
  <ion-card-header>
    <ion-card-title>Iktatási statisztika</ion-card-title>
    <ion-card-subtitle>Mennyi irat keletkezett, ki mennyit visz, és hol csúszik a határidő.</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="ev"
                 (ionBlur)="betolt()" style="max-width:120px"></ion-input>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <ng-container *ngIf="adat && !betoltes">
      <div class="ikt-szamok">
        <div class="ikt-szam">
          <div class="ertek">{{ adat.elintezes.atlag_nap ?? '–' }}</div>
          <div class="cimke">átlagos elintézési idő (nap)</div>
        </div>
        <div class="ikt-szam" [class.figyelem]="adat.elintezes.leghosszabb_nap > 30">
          <div class="ertek">{{ adat.elintezes.leghosszabb_nap ?? '–' }}</div>
          <div class="cimke">leghosszabb ügy (nap)</div>
        </div>
      </div>

      <h3 style="font-size:.95rem;margin:14px 0 6px">Havi bontás</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Hónap</th><th class="szam">Összes</th><th class="szam">Bejövő</th>
                     <th class="szam">Kimenő</th><th style="width:40%">Megoszlás</th></tr></thead>
          <tbody>
            <tr *ngFor="let h of adat.havonta">
              <td>{{ honapNev(h.honap) }}</td>
              <td class="szam">{{ h.db }}</td>
              <td class="szam">{{ h.bejovo }}</td>
              <td class="szam">{{ h.kimeno }}</td>
              <td>
                <div [style.width.%]="oszlopMagassag(h.db)"
                     style="height:10px;border-radius:5px;background:var(--ion-color-primary)"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!adat.havonta?.length">Ebben az évben még nem keletkezett irat.</div>
      </div>

      <h3 style="font-size:.95rem;margin:16px 0 6px">Ügyintézőnként</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Ügyintéző</th><th class="szam">Ügyirat</th><th class="szam">Folyamatban</th>
                     <th class="szam">Lejárt</th></tr></thead>
          <tbody>
            <tr *ngFor="let u of adat.ugyintezonkent">
              <td>{{ u.ugyintezo }}</td>
              <td class="szam">{{ u.ugyirat_db }}</td>
              <td class="szam">{{ u.folyamatban }}</td>
              <td class="szam">
                <ion-badge color="danger" *ngIf="u.lejart > 0">{{ u.lejart }}</ion-badge>
                <span *ngIf="!u.lejart">0</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!adat.ugyintezonkent?.length">Nincs adat.</div>
      </div>

      <h3 style="font-size:.95rem;margin:16px 0 6px">Iktatókönyvenként</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Jel</th><th>Könyv</th><th class="szam">Ügyirat</th><th class="szam">Irat</th></tr></thead>
          <tbody>
            <tr *ngFor="let k of adat.konyvenkent">
              <td class="iktszam">{{ k.jel }}</td>
              <td>{{ k.nev }}</td>
              <td class="szam">{{ k.ugyirat_db }}</td>
              <td class="szam">{{ k.irat_db }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!adat.konyvenkent?.length">Ebben az évben nincs iktatókönyv.</div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
